import React, { useState } from "react";
import { postCaja as addCaja } from "../helpers/rutaCajas";
import "../css/addclienteform.css";
import { Modal, Button } from "react-bootstrap";
import 'animate.css';

const AddCajaForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formValues, setFormValues] = useState({
    codcaj: "",
    descripcion: "",
    fecha: "",
    montoInicial: "",
  });

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const nuevaCaja = {
  //     ...formValues,
  //     saldoActual: formValues.montoInicial, // 👈 automático
  //   };

  //   addCaja(nuevaCaja).then((resp) => {
  //     console.log("✅ Caja creado:", resp);
  //     setFormValues({
  //       codcaj: "",
  //       descripcion: "",
  //       fecha: "",
  //       montoInicial: "",
  //     });
  //     // setShow(false); // si querés cerrar el modal
  //   });
  // };

const handleSubmit = async (e) => {
  e.preventDefault();

  const nuevaCaja = {
    ...formValues,
    saldoActual: formValues.montoInicial,
  };

  try {
    const resp = await addCaja(nuevaCaja);
    console.log("✅ Caja creada:", resp);

    setShowSuccess(true); // Mostrar modal de éxito

    setTimeout(() => {
      setShowSuccess(false); // Ocultar mensaje
      setFormValues({
        codcaj: "",
        descripcion: "",
        fecha: "",
        montoInicial: "",
      });
      // setShow(false); // Descomentá si querés cerrar el modal principal
    }, 2000);
  } catch (error) {
    console.error("❌ Error al crear caja:", error);
    // Podés agregar un modal de error acá si querés
  }
};


  return (
    <>
    <div className="container">
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group mt-3 col-sm-2">
            <label>Fecha Caja</label>
            <input
              type="datetime-local"
              className="form-control"
              name="fecha"
              required
              value={formValues.fecha}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3 col-sm-4">
            <label>Descripcion</label>
            <input
              type="text"
              className="form-control"
              name="descripcion"
              required
              maxLength="50"
              value={formValues.descripcion}
              onChange={handleChange}
            />
          </div>

          <div className="form-group mt-3 col-sm-2">
            <label>Monto Inicial</label>
            <input
              type="number"
              className="form-control"
              name="montoInicial"
              required
              value={formValues.montoInicial}
              onChange={handleChange}
            />
          </div>
       

        {/* Mostramos el saldo actual en modo lectura */}
   
          <div className="form-group mt-3 col-sm-2">
            <label>Saldo Actual</label>
            <input
              type="number"
              className="form-control"
              name="saldoActual"
              value={formValues.montoInicial}
              readOnly
            />
          </div>
        </div>

        <div>
          <button
            type="submit"
            className="btn btn-dark mt-5 mb-3"
            id="button"
          >
            Guardar
          </button>
        </div>
      </form>
    </div>
      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
           <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Registro generado correctamente!</h5>
        </Modal.Body>
    </Modal>

  </>
  );
};

export default AddCajaForm;
